export default __webpack_public_path__ + "static/media/zina.8b9c3448.jpeg";